import React, { Component } from "react";
import ReactDOM from "react-dom";
import { useNavigate } from "react-router-dom";


import {connect} from "react-redux";

const columns = [
    { title: "User", data:'name' },
    { title: "Agent", data:'agent' },
    { title: "IP Address", data:'ip' },
    { title: "Ban Date", data:"ban_date"},
    { title: "Ban Removal Date", data:"ban_removal_date"},
    { title: "Chat", data:"chat"},
    { title: "Remove", data:"name"},
];
@connect((store) => {
    return {
        chatprop: store.chatprop
    };
})
class BannedUsersDatatable extends Component {
    constructor(props) {
        super(props);

        this.searchDatatable=this.searchDatatable.bind(this);
        this.searchValue=React.createRef();
		this.gotoChat=this.gotoChat.bind(this);
    }
	
	gotoChat(id){
        this.props.navigate("/archive/"+id);
    }

    componentDidMount() {
        this.$el = $(this.el);

        this.$el.DataTable({
            dom: '<"data-table-wrapper'+this.props.id+'"t>',
            data: this.props.chatprop.bannedUsers,
            columns: columns,
            ordering: true,
            order:[[ 1, "asc" ]],
            columnDefs: [
                {
                    targets: [5],
                    className: "center",
                    createdCell: (td, cellData, rowData) =>
                        ReactDOM.render(
                            <React.Fragment>
                                    <a
                                                            className="btn btn-outline-primary btn-md"
                                                            onClick={() => this.gotoChat(rowData.chat)}

                                                        >Go To Chat</a>
                            </React.Fragment>
                            , td ), 
				},
				{
                    targets: [6],
                    className: "center",
                    createdCell: (td, cellData, rowData) =>
                        ReactDOM.render(
                            <React.Fragment>
                                    <a href="" className=" btn btn-trigger mr-2 text-primary btn-icon " onClick={e=>this.props.removeBannedUser(e, rowData.id)} ><i className="bx bx-trash icon" title="Remove"></i></a>
                            </React.Fragment>
                            , td ), 
				},
            ],
        });
    }
    searchDatatable(){
        var table = $('.data-table-wrapper'+ this.props.id).find('table').DataTable();
        table.search(this.searchValue.current.value).draw();
    }
    componentWillUnmount() {
        $(".data-table-wrapper"+this.props.id).find("table").DataTable().destroy(true);
    }
    reloadTableData = (data) => {

        var table = $('.data-table-wrapper'+ this.props.id).find('table').DataTable();

        table.clear();
        table.rows.add(data);
        table.draw();
    }
    shouldComponentUpdate(nextProps, nextState){

         this.reloadTableData(nextProps.chatprop.bannedUsers);

        return false;
    }
    render() {
        return (
            <React.Fragment>
                <div className="search_chat has-search ml-0 mb-3">
                    <span className="bx bx-search-alt form-control-feedback"></span>
                    <input className=" chat_input" type="text"
                           onKeyUp={e=>this.searchDatatable(e)}
                           ref={this.searchValue}
                           placeholder="Search User..." />
                </div>
                <table className="display nowrap"
                       id={"dataTable"+this.props.id}
                       width="100%"
                       cellSpacing="0"
                       ref={(el) => (this.el = el)}
                />
            </React.Fragment>
        );
    }
}

function WithNavigate(props) {
    let navigate = useNavigate();
    return <BannedUsersDatatable {...props} navigate={navigate} />
}

export default WithNavigate
//export default BannedUsersDatatable;
